var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"top-toast"}},[(_vm.visible)?_c('div',{staticClass:"top-toast"},[_vm._v("你的網路現在是離線狀態")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }